import axios from 'axios';
// import { setInetStatus } from './redux/actions/index'
// import store from './redux/store/index'

//Create a Http Client using Axios. Further modifications in this layer can be done later like Authorization.
// const WebServer = '/mockData';
// const WebServer = 'http://localhost/AryanFd';
// const WebServer = 'http://shivkalafd.com';
const WebServer = 'http://shivkalafd.olsystech.com';
const extension = '.php';

function getSalt() {
    return new Promise((resolve, reject) => {
        const slt = sessionStorage.getItem('uo');
        if (slt == null) {
            //if session is not set, redirect to login
            // resolve(0);
            resolve(0);
        } else {
            resolve(slt);
        }
    });
}
const post = (url = '', data = '', config = {}) => {
    const slt = getSalt2();
    axios.defaults.headers.common['Authorization'] = slt;
    return axios
        .post(WebServer + url + extension, data, config)
        .then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            alert('no internet');
        });
};
const login = (url = '', data = '', config = {}) => {
    return axios
        .post(WebServer + url + extension, data, config)
        .then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            alert('no internet');
        });
};

const get = url => {
    return new Promise((resolve, reject) => {
        // const slt = getSalt2();
        getSalt().then(salt => {
            if (salt !== 0) {
                axios.defaults.headers.common['Authorization'] = salt;
                axios(WebServer + url + extension)
                    .then(function(res) {
                        if (res.data === 'Security Error') {
                            resolve([]);
                            sendToLogin();
                        } else {
                            resolve(res.data);
                        }
                    })
                    .catch(function(err) {
                        return err;
                    });
            } else {
                sendToLogin();
            }
        });
    });

    // return;
    // axios.defaults.headers.common['Authorization'] = slt;
    // return axios(WebServer + url + extension)
    //     .then(function(res) {
    //         if (res.data === 'Security Error') {
    //             sendToLogin();
    //             return;
    //         }
    //         return res.data;
    //     })
    //     .catch(function(err) {
    //         return err;
    //     });
};
function getSalt2() {
    // const p = new Promise();

    const slt = sessionStorage.getItem('uo');

    if (slt == null) {
        //if session is not set, redirect to login
        sendToLogin();
        // p.resolve(0);
    } else {
        // p.resolve(slt)
        return slt;
    }
}
function sendToLogin() {
    const path = window.location.href;
    window.location = path.substring(0, path.indexOf('#/') + 1);
}
//Encapsulating in a JSON object
const HttpClient = {
    login,
    post,
    get,
    WebServer,
};

export default HttpClient;
